import { render } from "./LocalAdventure.vue?vue&type=template&id=e2d8d928"
import script from "./LocalAdventure.vue?vue&type=script&lang=js"
export * from "./LocalAdventure.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__